import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export const useProfile = () => {
  const { isAuthenticated } = useAuth();
  
  const queryResult = useQuery({
    queryKey: ["profile"],
    enabled: isAuthenticated,
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error("No user found");

      const { data, error } = await supabase
        .from("profiles")
        .select(
          `
          *,
          user_memberships!left(
            credits_balance,
            next_renewal_date,
            memberships(
              name,
              credits_per_month
            )
          )
        `
        )
        .eq("id", user.id)
        .maybeSingle();

      if (error) {
        console.error("Error fetching profile:", error);
        throw error;
      }

      return data ? { ...data, email: user.email } : null;
    },
  });

  return queryResult;
};